import { ref } from "vue";

export function handelYear(params) {
  const currentYearInfo = ref("");
  currentYearInfo.value = new Date().getFullYear();
  return {
    currentYearInfo,
  };
}
